import { render, staticRenderFns } from "./PopoverPanel.vue?vue&type=template&id=54519064&scoped=true"
import script from "./PopoverPanel.vue?vue&type=script&lang=js"
export * from "./PopoverPanel.vue?vue&type=script&lang=js"
import style0 from "./PopoverPanel.vue?vue&type=style&index=0&id=54519064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54519064",
  null
  
)

export default component.exports